import React from 'react';

/**
 * Displays the attendance shift name; special shifts show a small asterisk at top-right.
 */
export default function AttendanceShiftName({ name, isSpecialShift = false }) {
  const label = name?.trim() || '—';

  if (!isSpecialShift) {
    return <span>{label}</span>;
  }

  return (
    <span className="relative inline-block pr-2.5" title="Special shift">
      {label}
      <span
        className="absolute top-0 right-0 text-amber-600 text-[10px] font-bold leading-none translate-x-0.5 -translate-y-0.5"
        aria-hidden="true"
      >
        *
      </span>
    </span>
  );
}
